import React from 'react';
import { Box } from '@mui/material';

type TeksTimeBrandMarkProps = {
  height?: number;
  mb?: number;
};

/** Official TEKS TIME logo for auth/recovery screens (never plain text branding). */
const TeksTimeBrandMark: React.FC<TeksTimeBrandMarkProps> = ({ height = 48, mb = 2 }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb }}>
    <img
      src="/logo1.svg"
      alt="TEKS TIME Logo"
      style={{ height, width: 'auto' }}
    />
  </Box>
);

export default TeksTimeBrandMark;
